<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader" />
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate" />
      <rule-game :title="ruleTitle.rule" :value="ruleGame" />
      <rule-game :title="ruleTitle.score" :value="ruleScore" />
      <rule-game :title="ruleTitle.specialCard" :value="ruleSpecialCard" />
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/tk3/Tk3-Board.png';
import cardRank1 from '../../assets/gamerule/tk3/rank/1.png';
import cardRank2 from '../../assets/gamerule/tk3/rank/2.png';
import cardRank3 from '../../assets/gamerule/tk3/rank/3.png';
import cardRank4 from '../../assets/gamerule/tk3/rank/4.png';
import cardRank5 from '../../assets/gamerule/tk3/rank/5.png';
import cardSpecial1 from '../../assets/gamerule/tk3/specialcard/1.png';
import cardSpecial2 from '../../assets/gamerule/tk3/specialcard/2.png';
import cardSpecial3 from '../../assets/gamerule/tk3/specialcard/3.png';
import cardSpecial4 from '../../assets/gamerule/tk3/specialcard/4.png';
import cardSpecial5 from '../../assets/gamerule/tk3/specialcard/5.png';
import cardSpecial6 from '../../assets/gamerule/tk3/specialcard/6.png';

export default {
  name: 'rule_tk_3cards',
  data() {
    return {
      ruleHeader: {
        gameName: 'ตีไก่ 3 ใบ (Dragon battle royal 3 Cards)',
        boardImg: Board,
      },
      ruleTitle: {
        payRate: 'อัตราการจ่าย',
        rule: 'กติกา',
        score: 'แต้มไพ่',
        specialCard: 'ไพ่พิเศษ',
      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1:0.97',
          class: 'ml-3',
        },
        {
          type: 'text',
          text:
            'หากผู้เล่นลงเดิมพัน 100 บาท และได้รับชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท',
          class: 'ml-3',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text:
            'อัตราเดิมพันต่อรอบจะเท่ากับจำนวนเดิมพัน หน้าห้องหนึ่งห้องจะมีผู้เล่นได้สูงสุด 6 คน และสามารถเริ่มเล่นได้ตั้งแต่ 2 คน ขึ้นไปจะเริ่มแจกจากคนแรกเรียงไปทางขวาตามลำดับจนถึงคนสุดท้าย ผู้เล่นที่ได้แต้มเยอะที่สุดจะได้กินรอบวง อันดับสองจ่ายให้อันดับหนึ่งเพียงคนเดียวและได้รับจากคนรอบวง ไปจนถึงผู้เล่นที่แต้มน้อยที่สุดจะจ่ายรอบวงเมื่อเริ่มเกมส์ใหม่ ผู้เล่นที่ได้แต้มมากที่สุดจาก เกมส์ที่แล้วจะได้ไพ่เป็นคนแรกและแจกเรียงไปทางขวา',
          class: 'ml-3',
        },
      ],
      ruleScore: [
        {
          type: 'text',
          text:
            'ลำดับดอกไพ่เรียงจากมากไปน้อย',
          class: 'ml-3',
        },
        {
          type: 'text',
          text:
            'โพธิ์ดำ > โพธิ์แดง > ข้าวหลามตัด > ดอกจิกและตัวคุมเรียงจากมากไปน้อยเช่น',
          class: 'ml-3',
        },
        {
          type: 'text',
          text: 'A > K > Q > J > 10 > 9 > 8 > 7 > 6 > 5 > 4 > 3 > 2',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: cardRank1,
          class: 'w-50',
          text: 'โพธิ์ดำ > โพธิ์แดง > ข้าวหลามตัด > ดอกจิก',
        },
        {
          type: 'text',
          text:
            'หากได้ไพ่ K Q  J สองใบให้ได้แต้มเท่ากับ 7.5 แต้มหากได้ไพ่ดอกเดียวกันจะได้ 2 เด้ง',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: cardRank2,
          class: 'w-50',
        },
        {
          type: 'text',
          text:
            'ไพ่ในมือบวกกันนับแต้ม แต้มใหญ่สุดชนะโดยเรียงลำดับแต้มจากมากไปน้อย 9 > 8 > 7 > 6 > 5 > 4 > 3 > 2 > 1 > บอด',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: cardRank3,
          class: 'w-50',
        },
        {
          type: 'text',
          text: 'หากได้ 5 5 หรือ 10 10 จะได้บอด 2 เด้ง',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: cardRank4,
          class: 'w-50',
        },
        {
          type: 'text',
          text:
            'และผู้เล่นที่ได้แต้มมากที่สุดจะเป็นคนแรกที่ได้ไพ่และแจกเรียงไปทางขวา และรวมแต้มทั้ง 3 ใบรวมกัน ผู้เล่นที่ได้แต้มเยอะที่สุดเป็นผู้ชนะ',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: cardRank5,
          class: 'w-50',
        },
      ],
      ruleSpecialCard: [
        {
          type: 'text',
          text: '1.เรียงฟลัช',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: cardSpecial1,
          class: 'w-50',
          text: 'คือ ไพ่ที่เรียงกันและดอกเดียวกันได้ 5 เท่า',
        },
        {
          type: 'text',
          text: '2.ตอง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: cardSpecial2,
          class: 'w-50',
          text:
            'คือ ไพ่ที่มีแต้มเหมือนกัน 3 ใบ( ดอกและสีไม่จำเป็นต้องเหมือนกัน )ได้ 5 เท่า',
        },
        {
          type: 'text',
          text: '3.เรียง QKA - 123',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: cardSpecial3,
          class: 'w-50',
          text:
            'เริ่มนับจากแต้มน้อยที่สุด 1 > 2 > 3   จนถึงแต้มมากที่สุด Q > K > A ได้ 3 เท่า',
        },
        {
          type: 'text',
          text: '4.เซียน',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: cardSpecial4,
          class: 'w-50',
          text:
            'ไพ่เซียน คือ ไพ่ J Q K( ดอกหรือสีอะไรก็ได้ไม่จำเป็นต้องเรียง )ได้ 3 เท่า',
        },
        {
          type: 'text',
          text: '5. 3 เด้ง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: cardSpecial5,
          class: 'w-50',
          text: 'คือ ไพ่ที่ดอกเหมือนกัน 3 ใบได้ 3 เท่า',
        },
        {
          type: 'text',
          text: '6. 2 เด้ง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: cardSpecial6,
          class: 'w-50',
          text: 'คือ ไพ่ที่จำนวนแต้มเท่ากัน2 ใบ หรือ ดอกเดียวกัน 2 ใบได้ 2 เท่า',
        },
      ],
    };
  },
};
</script>
